import {
  Component,
  ContentChildren,
  Directive,
  EventEmitter,
  Input,
  NgModule,
  Output,
  QueryList,
} from '@angular/core';
import {SD_OPTION_PARENT, SdOption, SdOptionParent} from './option';
import {SdOptionModule} from './core';

export class SdAutocompleteSelectedEvent {
  constructor(public source: SdAutocomplete, public option: SdOption) {}
}

@Component({
  selector: 'sd-autocomplete',
  exportAs: 'sdAutocomplete',
  standalone: true,
  template: `
    @if (showPanel) {
      <div class="sd-autocomplete absolute z-[80] mt-1 max-h-60 w-full overflow-auto rounded-lg border border-[var(--m365-border-rest,#ececf0)] bg-white py-1 shadow-lg">
        <ng-content></ng-content>
      </div>
    }
  `,
  host: {class: 'sd-autocomplete-host relative block'},
  providers: [{provide: SD_OPTION_PARENT, useExisting: SdAutocomplete}],
})
export class SdAutocomplete implements SdOptionParent {
  @Input() displayWith: ((value: unknown) => string) | null = null;
  @Input() autoActiveFirstOption = false;
  @Output() optionSelected = new EventEmitter<SdAutocompleteSelectedEvent>();
  @ContentChildren(SdOption, {descendants: true}) options!: QueryList<SdOption>;
  showPanel = true;

  selectOption(option: SdOption): void {
    this.optionSelected.emit(new SdAutocompleteSelectedEvent(this, option));
  }

  isOptionSelected(): boolean {
    return false;
  }
}

@Directive({
  selector: '[sdAutocomplete]',
  standalone: true,
})
export class SdAutocompleteTrigger {
  @Input() sdAutocomplete: SdAutocomplete | null = null;
}

@NgModule({
  imports: [SdAutocomplete, SdAutocompleteTrigger, SdOptionModule],
  exports: [SdAutocomplete, SdAutocompleteTrigger, SdOptionModule],
})
export class SdAutocompleteModule {}

export {SdOption} from './option';
